import { render, staticRenderFns } from "./form-date-selector.vue?vue&type=template&id=d5852018&scoped=true&"
import script from "./form-date-selector.vue?vue&type=script&lang=ts&"
export * from "./form-date-selector.vue?vue&type=script&lang=ts&"
import style0 from "./form-date-selector.vue?vue&type=style&index=0&id=d5852018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5852018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
